import clsx from "clsx";
import type { ReactNode } from "react";
import React from "react";
import { useCompanyVendors } from "~/hooks/useCompanyVendors";
import { useConstructionItems } from "~/hooks/useConstructionItems";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import type { ConstructionItem } from "~/models/ConstructionItem";
import SettingStyles from "../../SettingStyle.module.scss";
import Styles from "./ConstructionItemSettingList.module.scss";
import { ConstructionItemSettingListRow } from "./ConstructionItemSettingListRow";

export const ConstructionItemSettingList: React.FC = () => {
	const { data: constructionItems } = useConstructionItems().index();
	const vendorCompanyId = useIdQueryHandler("vendorCompanyId");
	const { data: companyVendors } = useCompanyVendors().index();
	const vendorCompany = React.useMemo(() => {
		if (companyVendors === null || vendorCompanyId === null) {
			return null;
		}
		return (
			companyVendors.find(
				(company) => company.vendorCompany?.id === vendorCompanyId
			)?.vendorCompany ?? null
		);
	}, [companyVendors, vendorCompanyId]);
	const renderItemSettings = React.useCallback(
		(constructionItem: ConstructionItem): ReactNode => (
			<ConstructionItemSettingListRow
				constructionItem={constructionItem}
				key={constructionItem.id}
			/>
		),
		[]
	);
	if (constructionItems === null || vendorCompany === null) {
		return null;
	}
	return (
		<div>
			<h1 className={Styles.TitleList}>
				<span className={Styles.vendorCompanyName}>{vendorCompany.name}</span>
				<span className={SettingStyles.SettingTitle}>工事単価一覧</span>
			</h1>
			<table className={Styles.List}>
				<thead>
					<tr className={clsx(Styles.ListRow, Styles.Header)}>
						<th>項目名</th>
						<th>単価</th>
					</tr>
				</thead>
				<tbody>{constructionItems.map(renderItemSettings)}</tbody>
			</table>
		</div>
	);
};
